import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

interface LayoutProps {
  children: React.ReactNode;
  showBreadcrumb?: boolean;
}

export default function Layout({ children, showBreadcrumb = true }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-16">
        {showBreadcrumb && <Breadcrumb />}
        {children}
      </main>
      <Footer />
    </div>
  );
}